// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3yxC4","rightAdornment":"Header_rightAdornment__5s7M9"};